import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';

import { switchDataSet } from '@redux/actions/AuthActions';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import Button from '@material-ui/core/Button';

import clsx from 'clsx';

import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';

const HidedTableHead = withStyles((theme) => ({
  root: {
    display: 'none'
  }
}))(TableHead);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 12,
    borderBottom: 'none !important'
  }
}))(TableCell);

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    fontWeight: 'bold'
  },
  body: {
    fontSize: 12,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitleStrong = withStyles((theme) => ({
  body: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important',
    '& span': {
      color: '#ff9800',
      fontWeight: 'normal'
    }
  }
}))(TableCell);

const TableCellTitle = withStyles((theme) => ({
  body: {
    fontSize: 14,
    borderBottom: 'none !important',
    '& span': {
      color: '#ff9800'
    }
  }
}))(TableCell);

const NetTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(14,78,173,0.2)',
    border: 'none'
  }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700
  },
  tableContainer: {
    borderTop: '5px solid #CD0032',
    margin: '30px auto !important'
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',

    '& p': {
      marginLeft: 20,
      fontSize: 12
    },
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  },
  input: {
    maxWidth: 75,
    width: 75,
    minHeight: 30,
    padding: 10,
    textAlign: 'center',
    border: '2px solid #002380',
    borderRadius: '5px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    padding: 30,
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    '& p': {
      fontSize: 14,
      color: '#001E41'
    },
    '& svg': {
      color: '#001E41'
    }
  },
  expandOpen: {
    '& svg': {
      transform: 'rotate(180deg)'
    }
  },
  expandIconContainer: {
    display: 'flex',
    justifyContent: 'right',
    '& > button.MuiIconButton-root:hover': {
      backgroundColor: 'unset'
    }
  }
}));

const TableBalance = ({ dataSet }) => {
  const outputs = useSelector((state) => state.FinancialModelReducer.outputs);

  const [expanded, setExpanded] = useState(false);

  const classes = useStyles();

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <div className={classes.header}>
        <h2>Balance sheet</h2>
        <p>
          As of year end 31/12, all figures in EURm (except otherwise stated)
        </p>
      </div>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellStrong />
            <StyledTableCellStrong align="center">2019</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2020E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2021E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2022E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2023E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2024E</StyledTableCellStrong>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCellTitle>Goodwill & intangibles</TableCellTitle>
            {Object.values(outputs.goodwill)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Tangible fixed assets</TableCellTitle>
            {Object.values(outputs.tangible_fixed)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Net working capital</TableCellTitle>
            {Object.values(outputs.net_fin_debt)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Associates</TableCellTitle>
            {Object.values(outputs.asso)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <NetTableRow>
            <TableCellTitleStrong>Total net assets</TableCellTitleStrong>
            {Object.values(outputs.total_net_liab)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </NetTableRow>
          <TableRow>
            <TableCellTitle>Equity excl minorities</TableCellTitle>
            {Object.values(outputs.equity_ex_mino)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Minorities</TableCellTitle>
            {Object.values(outputs.mino)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Net financial debt (+net debt/-net cash)
            </TableCellTitle>
            {Object.values(outputs.net_fin_debt)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Provisions</TableCellTitle>
            {Object.values(outputs.provisions)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Pension liabilities, net of assets</TableCellTitle>
            {Object.values(outputs.pension_liab)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Deferred tax liabilities, net of assets
            </TableCellTitle>
            {Object.values(outputs.deferred_tax_liab)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Liabilities held for sale, net of assets
            </TableCellTitle>
            {Object.values(outputs.liab_held_sale)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Other liabilities, net of assets</TableCellTitle>
            {Object.values(outputs.other_liab)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <NetTableRow>
            <TableCellTitleStrong>Total net liabilities</TableCellTitleStrong>
            {Object.values(outputs.total_net_liab)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </NetTableRow>
        </TableBody>
      </Table>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Table className={classes.table} size="small">
          <TableBody>
            <TableRow>
              <TableCellTitleStrong>
                Computation of net Financial Debt
              </TableCellTitleStrong>
            </TableRow>
            <TableRow>
              <TableCellTitle>Cash and cash equivalents</TableCellTitle>
              {Object.values(outputs.cash_cash_eq)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>
                Gross financial debt <br />{' '}
                <span>(short-term + long-term)</span>
              </TableCellTitle>
              {Object.values(outputs.gross_fin_debt)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <NetTableRow>
              <TableCellTitleStrong>
                Total Net financial debt <br />{' '}
                <span>(+net debt/-net cash)</span>
              </TableCellTitleStrong>
              {Object.values(outputs.total_net_fin_debt)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </NetTableRow>
            <TableRow>
              <TableCellTitleStrong>
                Computation of Capital Employed
              </TableCellTitleStrong>
            </TableRow>
            <TableRow>
              <TableCellTitle>Tangible fixed assets, net</TableCellTitle>
              {Object.values(outputs.tangible_fixed)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>Gross GW & other intangibles</TableCellTitle>
              {Object.values(outputs.gross_gw_other_intangible)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>
                + Add-back historical impairment of GW & intangible assets
              </TableCellTitle>
              {Object.values(outputs.add_back_histo_imp_gw_intangible)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>Net working capital</TableCellTitle>
              {Object.values(outputs.net_income)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <NetTableRow>
              <TableCellTitleStrong>
                Net capital employed (NCE) - I
              </TableCellTitleStrong>
              {Object.values(outputs.net_income)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </NetTableRow>
            <TableRow>
              <TableCellTitle>
                -Gross GW & other intangibles - II
              </TableCellTitle>
              {Object.values(outputs.gross_gw_other_intangible)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>
                -Historical impairment of GW/Intangibles - III
              </TableCellTitle>
              {Object.values(outputs.gross_gw_other_intangible)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <NetTableRow>
              <TableCellTitleStrong>
                Net tangible capital employed (NTCE) (I) + (II) + (III)
              </TableCellTitleStrong>
              {Object.values(outputs.net_income)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </NetTableRow>
          </TableBody>
        </Table>
      </Collapse>
      <div className={classes.expandIconContainer}>
        <IconButton
          aria-expanded={expanded}
          aria-label="show more"
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          disableRipple
          onClick={handleExpandClick}>
          <p>{expanded ? 'hide details' : 'expand for more details'}</p>
          <ExpandMoreIcon />
        </IconButton>
      </div>
    </TableContainer>
  );
};

export default TableBalance;
